import React from 'react';

import Tabs from '../tabs/tabs';
import SectionHeader from '../SectionHeader';
import Infographic from '../Infographic';
import trans from '../../translations.json';
import ActiveOutbreaks from '../activeOutbreaks/activeOutbreaks';
import ActiveOutbreaksTable from '../activeOutbreaks/activeOutbreaks-table';
import BySourceSetting from '../bySourceSetting/bySourceSettingIndex';
import BySourceAll from '../bySourceAll/bySourceAllIndex';
// import ReducedData from '../../reducedData.json';
import OnThisPage from '../onThisPage/onThisPage';
// import dict from '../../dictionary';
// var covidData = ReducedData.covidData;
// const latest = covidData[covidData.length - 1];
// const previous = covidData[covidData.length - 2];
// const totalSince = 'Jan 15, 2020';

const Sources = (props) => {
  // const stats = {
  //   curr: [
  //     {
  //       label: trans.hospital.hospitalized[props.lang],
  //       value: latest[dict.patientHospitalizedCOVID19],
  //       difference:
  //         latest[dict.patientHospitalizedCOVID19] -
  //         previous[dict.patientHospitalizedCOVID19],
  //     },
  //     {
  //       label: trans.overview.icuAbbr[props.lang],
  //       value: latest[dict.patientsICUwCOVID19],
  //       difference:
  //         latest[dict.patientsICUwCOVID19] -
  //         previous[dict.patientsICUwCOVID19],
  //     },
  //     {
  //       label: trans.hospital.ventilator[props.lang],
  //       value: latest[dict.patientsICUventilatorwCOVID19],
  //       difference:
  //         latest[dict.patientsICUventilatorwCOVID19] -
  //         previous[dict.patientsICUventilatorwCOVID19],
  //     },
  //   ],
  // };
  return (
    <>
      <p>{props.momentBuildTime}</p>
      <OnThisPage
        lang={props.lang}
        sections={[
          {
            href: '#allSources',
            category: 'otp',
            text: 'allSources',
          },
          {
            href: '#obSetting',
            category: 'otp',
            text: 'obSetting',
          },
          {
            href: '#where_numbers',
            category: 'otp',
            text: 'numberscomefrom',
          },
        ]}
      />

      <SectionHeader
        id="allSources"
        title={trans.otp.allSources}
        lastUpdated={props.lastUpdated}
        lang={props.lang}
      >
        <div className="ontario-row ">
          <div className="ontario-columns ontario-small-12 ontario-medium-12 ontario-margin-bottom-32-!">
            <Infographic
              id="bySource"
              lang={props.lang}
              bar={
                <Tabs
                  lang={props.lang}
                  newCases={
                    <BySourceAll
                      lang={props.lang}
                      selectedTab="newCases"
                    />
                  }
                  totalCases={
                    <BySourceAll
                      lang={props.lang}
                      selectedTab="totalCases"
                    />
                  }
                />
              }
              width="default"
            />
          </div>
        </div>
      </SectionHeader>

      <SectionHeader
        id="obSetting"
        title={trans.otp.obSetting}
        lastUpdated={props.lastUpdated}
        lang={props.lang}
      >
        <div className="ontario-row ">
          <div className="ontario-columns ontario-small-12 ontario-medium-12 ontario-margin-bottom-32-!">
            <h4>{trans.bySource.title[props.lang]}</h4>
            <Infographic
              id="byLikelySource"
              lang={props.lang}
              bar={
                <Tabs
                  lang={props.lang}
                  newCases={
                    <BySourceSetting
                      lang={props.lang}
                      selectedTab="newCases"
                    />
                  }
                  totalCases={
                    <BySourceSetting
                      lang={props.lang}
                      selectedTab="totalCases"
                    />
                  }
                />
              }
              width="default"
            />
          </div>
        </div>

        <div className="ontario-row ">
          <div className="ontario-columns ontario-small-12 ontario-medium-12 ontario-margin-bottom-32-!">
            <h4>{trans.activeOutbreaks.title[props.lang]}</h4>
            <Infographic
              id="ActiveOutbreaks"
              lang={props.lang}
              opts={['bar', 'table']}
              bar={
                <ActiveOutbreaks
                  lang={props.lang}
                  chartTitle={trans.casesByAge.title[props.lang]}
                />
              }
              table={<ActiveOutbreaksTable lang={props.lang} />}
              width="default"
            />
          </div>
        </div>
      </SectionHeader>
    </>
  );
};

export default Sources;
